import { render, staticRenderFns } from "./LayoutCMS.vue?vue&type=template&id=6fc39521"
import script from "./LayoutCMS.vue?vue&type=script&lang=js"
export * from "./LayoutCMS.vue?vue&type=script&lang=js"
import style0 from "./LayoutCMS.vue?vue&type=style&index=0&id=6fc39521&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports